import { html } from '@polymer/polymer/polymer-element';
import { KatapultWidget } from './katapult-widget';

import '../../paper-table/paper-table';
import '../../style-modules/paper-table-style';
import '../../paper-header/paper-header';

import '@polymer/paper-menu-button/paper-menu-button.js';
import '../../style-modules/paper-menu-button-style.js';
import '@polymer/iron-icons/av-icons';

class CompanyResources extends KatapultWidget {
  static get widgetTitleTemplate() {
    return html`Company Resources`;
  }

  static get bodyTemplate() {
    return html`
      <style include="paper-table-style">
        paper-row {
          height: auto;
        }
        .resWrapper {
          box-sizing: border-box;
          padding: 10px;
          margin: 0;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          transition: background-color 0.3s;
        }
        .resWrapper.invalid {
          animation: pulseAnim 10s ease-out infinite;
        }
        @keyframes pulseAnim {
          90% {
            transform: scale(1);
          }
          91% {
            transform: scale(1.05);
          }
          95% {
            transform: scale(1);
          }
        }
        .resWrapper:hover {
          background-color: var(--paper-grey-50);
        }
        .signoffWrapper {
          padding-left: 10px;
          display: grid;
          grid-template-columns: 1fr 100px;
          align-items: center;
          border-radius: 5px;
          transition: all 0.3s ease-out;
        }
        .lastUpdatedDate {
          color: #aaa;
          font-style: italic;
          font-size: 9pt;
        }
        .signoffLabel {
          color: #aaa;
          font-style: italic;
        }
        .invalid .signoffLabel {
          color: #fff;
        }
        .soonInvalid .signoffLabel {
          color: #fff;
        }
        .resTitle {
          font-size: 14pt;
          color: #555;
        }
        .resDesc {
          color: #777;
        }
        /* Make the links prettier, if less obvious */
        a {
          color: inherit;
          text-decoration: inherit;
        }
        .signoffWrapper.invalid {
          /* color:white;
          background:#990026; */
          /* This animation is a bit of a hack to prevent a 'FOUC'ish jank as the signature logs load */
          /* ...As long as the signature log loads in less than 0.5s :)  */
          animation: invalidAnim 0.5s ease-out forwards;
        }
        @keyframes invalidAnim {
          0% {
            color: #aaa;
            background: none;
          }
          90% {
            color: #aaa;
            background: none;
          }
          100% {
            color: white;
            background: #990026;
          }
        }

        .signoffWrapper.soonInvalid {
          color: white;
          background: #ff8300;
        }
        .checkWrapper {
          display: flex;
          align-items: center;
        }
        .linkColor {
          color: var(--primary-color);
          display: flex;
          align-content: center;
        }
        .linkColor:hover {
          text-decoration: underline;
        }
        #adminToolbar {
          /* border:1px solid #EEE; */
          /* border-radius:10px; */
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin: 0px;
          box-sizing: border-box;
          padding: 5px 10px 5px 10px;
          background: #eee;
        }
        .spaceBetween {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .reportRow.invalid {
          background: #990026;
          color: white;
        }
      </style>

      <!-- Admin tools -->

      <!-- Admin toolbar -->
      <template is="dom-if" if="[[isAdmin]]">
        <div id="adminToolbar">
          <div class="resTitle">Admin Tools</div>
          <katapult-button color="var(--primary-color)" on-click="openAdminDialog" id="adminReportDialog_openButton"
            >Generate Reports</katapult-button
          >
          <katapult-button color="var(--primary-color)" on-click="openAdminDialog" id="adminResourceDialog_openButton"
            >Manage Resources</katapult-button
          >
        </div>

        <!-- Admin Dialogs -->
        <!-- These are here to keep them out of the DOM for non-admins (most users) -->

        <!-- Reporting Dialog -->
        <katapult-dialog-legacy id="adminReportDialog" draggable close-button style="width: 1000px;">
          <span slot="title">Generate Reports</span>

          <div slot="body">
            <template is="dom-repeat" items="[[docsList]]">
              <template is="dom-if" if="[[item.signoff_required]]">
                <div white divider class="resWrapper">
                  <div>[[item.name]]</div>
                  <div class="spaceBetween">
                    <div></div>
                    <katapult-button size="small" id$="[[item.$key]].activeUserSignature.button" on-click="getActiveSignatureReport">
                      Active User Signatures
                    </katapult-button>
                  </div>
                  <template is="dom-if" if="[[item.reportExists]]">
                    <template is="dom-if" if="[[item.reportGenerating]]">
                      <div>... Creating Report ...</div>
                    </template>

                    <template is="dom-if" if="[[!item.reportGenerating]]">
                      <div class="resTitle">[[item.reportType]] Report</div>
                      <paper-table>
                        <paper-row gray>
                          <paper-cell>UID</paper-cell>
                          <paper-cell>Name</paper-cell>
                          <paper-cell>Email</paper-cell>
                          <paper-cell>Last Signed</paper-cell>
                        </paper-row>

                        <template is="dom-repeat" items="[[item.report]]" as="row">
                          <paper-row
                            class$="reportRow [[getSignoffExpirationStatus(row.timeSigned, item.signoff_required, item.signoff_frequency)]]"
                          >
                            <paper-cell>[[row.uid]]</paper-cell>
                            <paper-cell>[[row.firstName]] [[row.lastName]]</paper-cell>
                            <paper-cell>[[row.email]]</paper-cell>
                            <paper-cell>[[row.dateSigned]]</paper-cell>
                          </paper-row>
                        </template>
                      </paper-table>
                    </template>
                  </template>
                </div>
              </template>
            </template>
          </div>
        </katapult-dialog-legacy>

        <!-- Resource Management Dialog -->
        <katapult-dialog-legacy id="adminResourceDialog" draggable close-button style="width: 500px;">
          <span slot="title">Manage Resources</span>

          <div slot="body">
            <h2>Tool coming soon, maybe</h2>
          </div>
        </katapult-dialog-legacy>
      </template>

      <template is="dom-repeat" items="[[docsList]]">
        <paper-row
          white
          divider
          class$="resWrapper [[getSignoffExpirationStatus(item.lastSignoff, item.signoff_required, item.signoff_frequency)]]"
        >
          <a href="[[item.href]]" target="_blank">
            <div class="resTitle">[[item.name]]<span class="lastUpdatedDate">[[emptyIfNullDate(item.last_updated)]]</span></div>
            <div class="resDesc">[[item.desc]]</div>
          </a>
          <template is="dom-if" if="[[item.signoff_required]]">
            <div class$="signoffWrapper [[getSignoffExpirationStatus(item.lastSignoff, item.signoff_required, item.signoff_frequency)]]">
              <div class="signoffLabel"><span>last signature: </span><span>[[neverIfNull(item.lastSignoff)]]</span></div>
              <katapult-button id$="[[index]]|[[item.$key]]|signoffButton" small on-click="openSignOff">Sign Now</katapult-button>
            </div>
          </template>
        </paper-row>
      </template>

      <!-- Dialogs -->
      <!-- Dialog to warn user of expired signatures -->
      <katapult-dialog-legacy id="warningDialog" no-cancel-on-outside-click style="width: 500px;">
        <span slot="title">Signature Required</span>

        <div slot="body">
          <h2>You have one or more documents that you must review and sign in Company Resources!</h2>
        </div>

        <div slot="buttons">
          <katapult-button on-click="acknowledgeSignRequired" primary-color>OK</katapult-button>
        </div>
      </katapult-dialog-legacy>

      <!-- Dialog with the signing tools -->
      <katapult-dialog-legacy id="signOffDialog" no-cancel-on-outside-click style="width: 500px;">
        <span slot="title">Sign [[signingResource.name]]</span>

        <div slot="body" flex-column>
          <a href="[[signingResource.href]]" target="_blank">
            <h2 class="linkColor">
              <material-icon icon="link" style="display:inline;margin-right:5px"></material-icon> [[signingResource.name]]
            </h2>
          </a>
          <!-- Require explicit confirmation/acknowledgement for signature -->
          <div class="checkWrapper">
            <paper-checkbox checked="{{signCertified}}" required></paper-checkbox>
            <div>[[getCertificationText(signingResource.cert_text)]]</div>
          </div>
        </div>

        <div slot="buttons">
          <katapult-button on-click="closeSignOff">Cancel</katapult-button>
          <katapult-button color="var(--primary-color)" on-click="signResource" disabled="[[!signCertified]]">Sign</katapult-button>
        </div>
      </katapult-dialog-legacy>
    `;
  }
  static get properties() {
    return {
      // Set this so that the padding goes away and the widget looks pretty
      paperTableBody: {
        type: Boolean,
        value: true
      },
      // All the resource definition data
      docsList: {
        type: Object,
        value: []
      },
      // Keys for the resources in DocsList
      docsKeys: {
        type: Object,
        value: []
      },
      // How many days before a signature expiration we change the color to warn the user
      expirationWarning: {
        type: Number,
        value: 14
      },
      // Checkbox status on signature dialog
      signCertified: {
        type: Boolean,
        value: false
      },
      // Interval (in seconds) between warning popups about expired signatures
      pesterRate: {
        type: Number,
        value: 3600 //1 hour
      },
      // Assume not an admin until we determine it for real
      isAdmin: {
        type: Boolean,
        value: false
      },
      // register dialog ID's here so that they are checked before pestering a user
      dialogs: {
        type: Array,
        value: ['signOffDialog', 'warningDialog', 'adminReportDialog', 'adminResourceDialog']
      }
    };
  }

  // On you mark, get set, GO!
  ready() {
    super.ready();
    // kickoff everything by getting our list of resources
    this.getDocsList();
    this.setIsAdmin();
  }

  // determine if current user is a company resource admin
  setIsAdmin() {
    let uid = this.user.uid;
    this.isAdmin = Boolean(this.catalogData?.config.admins?.[uid]);
  }

  // return String 'Never' if date is null
  neverIfNull(date) {
    return date == null ? 'Never' : this.getHumanDate(date);
  }

  //return empty string if no date, otherwise return human date wrapped in parenthesis
  emptyIfNullDate(date) {
    return date == null ? '' : `  (${this.getHumanDate(date)})`;
  }

  // get a YYYY-MM-DD formatted date
  getHumanDate(date) {
    if (date != null) {
      let month = '' + (date.getMonth() + 1);
      let day = '' + date.getDate();
      return `${date.getFullYear()}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }

  // get the signoff status
  getSignoffExpirationStatus(lastSign, required, freqency) {
    //return valid if no signoff required
    if (!required) {
      return 'valid';
    }

    // return valid if there is no frequency requirement and the doc was ever signed
    if (freqency == null) {
      if (lastSign != null) {
        return 'valid';
      }
    }

    //create an empty array so that we can check a variety of factors at a later time and then return after all checks
    let statusMatches = [];

    // All remaining cases require a signature so...
    // return invalid if it was nevery signed
    if (lastSign == null) {
      statusMatches.push('invalid');
    }

    //set a date before which signatures are no longer valid
    let validSignDate = new Date();
    validSignDate.setDate(validSignDate.getDate() - freqency);

    //set a date before which signatures are about to expire
    let warnDate = new Date();
    warnDate.setDate(warnDate.getDate() - (freqency - this.expirationWarning));

    // return invalid if the last signature is older than the valid sign date
    if (validSignDate > lastSign) {
      statusMatches.push('invalid');
    }

    // return soonInvalid if the last signature is about to expire
    if (warnDate > lastSign) {
      statusMatches.push('soonInvalid');
    }

    //if there are any invalid critera, return invalid
    if (statusMatches.includes('invalid')) {
      return 'invalid';
    }

    //if there are any soonInvalid critera, return soonInvalid
    if (statusMatches.includes('soonInvalid')) {
      return 'soonInvalid';
    }

    // return valid for all remaining cases
    return 'valid';
  }

  // Get the list of resources for the widget
  getDocsList() {
    firebase
      .firestore()
      .collection(`/companies/${this.userGroup}/widget_data/company_resources/resources`)
      .onSnapshot((data) => {
        let docsKeys = [];
        let docsList = data.docs.map((x) => {
          let y = x.data();
          //add the id to the output
          y.$key = x.id;
          y.last_updated = this.getDateFromFirebaseTimeStamp(x.data().last_updated);
          return y;
        });

        // sort the list by the priority defined in firebase
        docsList.sort((a, b) => (a.priority > b.priority ? 1 : -1));
        this.docsList = docsList;

        // create a docsKeys array that matches the order of the docsList for ease of access
        this.docsList.map((x) => {
          docsKeys.push(x.$key);
        });

        this.docsKeys = docsKeys;
        // get the signoffs
        this.getSignOffList();
      });
  }

  //Gets the resource sign offs for this user, and matches them with the appropriate resourece.
  getSignOffList() {
    firebase
      .firestore()
      .collection(`/companies/${this.userGroup}/widget_data/company_resources/sign_offs`)
      .where('uid', '==', firebase.auth().currentUser.uid)
      .onSnapshot((data) => {
        data.docs.map((x) => {
          let signOff = x.data();
          let signTime = this.getDateFromFirebaseTimeStamp(signOff.time);

          // get the resource key for this signoff
          let resourceIndex = this.docsKeys.indexOf(signOff.resource_key);
          if (resourceIndex > -1) {
            // if the current sign off is newer than the last one for that resource, add it to our docsList
            if (this.docsList[resourceIndex].lastSignoff == null || this.docsList[resourceIndex].lastSignoff < signTime) {
              this.docsList[resourceIndex].lastSignoff = signTime;
              // notifyPath so that the DOM updates with changes
              this.notifyPath(`docsList.${resourceIndex}.lastSignoff`, signTime, 'changed');
            }
          }
        });

        setTimeout((x) => this.warnSignoffDates(x), 1000);
      });
  }

  //checks if any of the registered dialogs are open
  checkForOpenDialogs() {
    let anyOpened = false;

    // iterate the registered dialogs
    this.dialogs.every((x) => {
      // check if dialog is opened
      if (this.shadowRoot.querySelector(`#${x}`)?.opened) {
        anyOpened = true;
        // exit `every` loop
        return false;
      } else {
        // true to continue the `every` loop on the array
        return true;
      }
    });

    return anyOpened;
  }

  //check for any invalid signatures and warn the user if they exist
  warnSignoffDates() {
    this.docsList.every((x) => {
      if (this.getSignoffExpirationStatus(x.lastSignoff, x.signoff_required, x.signoff_frequency, x.last_updated) === 'invalid') {
        // Check if any dialogs are opened, warn the user to sign the docs if not
        if (!this.checkForOpenDialogs()) {
          this.shadowRoot.querySelector('#warningDialog').open();
        }
        // Return false to exit the `every` loop -- we just need one to make us open it.
        return false;
      } else {
        return true;
      }
    });
  }

  acknowledgeSignRequired() {
    this.shadowRoot.querySelector('#warningDialog').close();
    // Pester the user again if they have not completed the task after a specified time.
    // Yes, a part of me died from creating a tool to intentionally annoy the user.
    this.pesterUser();
  }

  // generate the text to show in the sign dialog, either using the text in the resource definition or with a generic message
  getCertificationText(certText) {
    if (certText && certText != '') return certText;
    return `I have fully read, understand and agree to adhere to the information in the ${this.signingResource.name} document.`;
  }

  // Check for invalid signature dates and warn the user after an interval
  pesterUser() {
    setTimeout((x) => this.warnSignoffDates(x), this.pesterRate * 1000);
  }

  // Shows the signoff dialog
  openSignOff(e) {
    // set some environmental variables before opening the dialog
    this.signingResourceKey = e.target.id.split('|')[1];
    this.signingResourceIndex = e.target.id.split('|')[0];
    this.signingResource = this.docsList[this.signingResourceIndex];
    // now open the dialog
    this.shadowRoot.querySelector('#signOffDialog').open();
  }

  closeSignOff(e) {
    this.shadowRoot.querySelector('#signOffDialog').close();
    //reset signCertified so that the user must recertify for the next resource
    this.set('signCertified', false);
    // Start a new pester timer that checks if the user has more documents to sign
    this.pesterUser();
  }

  //generates a JS Date object from a firebase timestamp
  getDateFromFirebaseTimeStamp(timestamp) {
    if (timestamp) {
      return new Date(timestamp.seconds * 1000);
    }
    return;
  }

  // add a signoff for the current resource
  signResource(e) {
    let refPath = `/companies/${this.userGroup}/widget_data/company_resources/sign_offs`;
    let update = {
      resource_key: this.signingResourceKey,
      time: new Date(),
      uid: firebase.auth().currentUser.uid
    };

    firebase.firestore().collection(refPath).doc().set(update);

    this.shadowRoot.querySelector('#signOffDialog').close();
    //reset signCertified so that the user must recertify for the next resource
    this.set('signCertified', false);
    // Start a new pester timer that checks if the user has more documents to sign
    this.pesterUser();
  }

  getDocIndexFromKey(key) {
    return this.docsKeys.indexOf(key);
  }

  //Admin Functions:
  //open dialogs
  openAdminDialog(e) {
    // get the dialog id from the button id
    let id = e.target.id.split('_')[0];
    // open it!
    this.shadowRoot.querySelector(`#${id}`).open();
  }

  // get report of active user's signatures
  async getActiveSignatureReport(e) {
    // get resource key
    let docKey = e.target.id.split('.')[0];
    // get report type
    let reportType = e.target.id.split('.')[1];
    let docIndex = this.getDocIndexFromKey(docKey);

    // set some stuff for view purposes
    this.set(`docsList.${docIndex}.reportGenerating`, true);
    this.set(`docsList.${docIndex}.reportExists`, true);

    // initialize our variables
    let queries = [];
    let allSignatures = [];
    let users = {};
    let signaturesByUser = {};

    // get the sign offs for the specified resource, also build a user-keyed object with the latest time, since we are already looping
    queries.push(
      await firebase
        .firestore()
        .collection(`/companies/${this.userGroup}/widget_data/company_resources/sign_offs`)
        .where('resource_key', '==', docKey)
        .get()
        .then((data) => {
          allSignatures = data.docs.map((x) => {
            let xdata = x.data();
            if (signaturesByUser[xdata.uid] == null || signaturesByUser[xdata.uid] < xdata.time.seconds) {
              signaturesByUser[xdata.uid] = xdata.time.seconds;
            }
            return xdata;
          });
        })
    );

    // get the list of users
    queries.push(
      FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/users`)
        .once('value')
        .then((s) => {
          users = s.val();
        })
    );

    await Promise.all(queries);

    // if this report is for active users, filter users to only active users
    if (reportType == 'activeUserSignature') {
      let cleanedUsers = {};
      for (let uid in users) {
        if (!['inactive', 'locked'].includes(users[uid].employment_status)) {
          cleanedUsers[uid] = users[uid];
        }
      }
      users = cleanedUsers;
    }

    // create a report array
    let report = [];
    Object.keys(users).forEach((uid) => {
      report.push({
        uid: uid,
        email: users[uid]?.email || '',
        firstName: users[uid]?.name?.first || '',
        lastName: users[uid]?.name?.last || '',
        dateSigned: signaturesByUser[uid] == null ? '' : this.getHumanDate(new Date(signaturesByUser[uid] * 1000)),
        timeSigned: signaturesByUser[uid] == null ? '' : signaturesByUser[uid] * 1000,
        jsDateSigned: signaturesByUser[uid] == null ? null : new Date(signaturesByUser[uid] * 1000)
      });
    });

    // clean up for the view
    this.set(`docsList.${docIndex}.reportGenerating`, false);
    this.set(`docsList.${docIndex}.reportType`, reportType);
    this.set(`docsList.${docIndex}.report`, report);
  }
}
window.customElements.define('company-resources', CompanyResources);
